import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  base: {
    color: '#000000',
  },
  level1: {
    fontSize: 24,
    fontWeight: '700',
  },
  level2: {
    fontSize: 18,
    fontWeight: '700',
  },
  level3: {
    fontSize: 14,
    fontWeight: '700',
  },
});
